import { Component, Inject } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserInfo } from '@models/auth.model';
import { N15Service } from './n15.service';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';
import { BankModel } from '@modules/admin/pages/n05/n05.model';
import { N05Service } from '@modules/admin/pages/n05/n05.service';
import { OrderModel } from '@modules/admin/pages/n07/n07.model';
import { CartModel } from './n15.model';
import { map, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-n15',
  templateUrl: './n15.component.html',
  styleUrls: ['./n15.component.scss']
})
export class N15Component {
  urlImg: string; // Đường dẫn ảnh người dùng đã chọn
  step: number;
  order: OrderModel; // mã code chuyển khoản
  cart: CartModel;
  columnsToData = [
    {
      columnDef: 'bankName',
      header: 'Tên ngân hàng',
      cell: (element: BankModel) => `${element.bankName}`,
    },
    {
      columnDef: 'bankNumber',
      header: 'Số tài khoản',
      cell: (element: BankModel) => `${element.bankNumber}`,
    },
    {
      columnDef: 'accountOwner',
      header: 'Chủ tài khoản',
      cell: (element: BankModel) => `${element.accountOwner}`,
    },
    {
      columnDef: 'bankBranch',
      header: 'Chi nhánh',
      cell: (element: BankModel) => `${element.bankBranch}`,
    },
  ]; // Danh sách cột và alias để map data
  isEdit: boolean[];
  displayedColumns = [...this.columnsToData.map(c => c.columnDef)]; // số cột cần hiển thị
  formInfo = new FormGroup({
    phone: new FormControl(null, [Validators.minLength(9), Validators.required, Validators.pattern(/^\d+$/)]),
    address: new FormControl(null, [Validators.required]),
  });
  fileName = new FormControl(null);
  file_store: File; // file img đã chọn
  dataSource: BankModel[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private dialogRef: MatDialogRef<N15Component>,
    private dialog: MatDialog,
    private n15Service: N15Service,
    private n05Service: N05Service
  ) {
    this.step = 1;
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.onSearch();
  }
  /**
   * lấy thông tin cart
   */
  onSearch() {
    this.n15Service.getCart().subscribe({
      next: response => {
        this.cart = response.data;
        this.isEdit = Array.from({ length: response.data.items.length }, () => false);
      }
    })
  }
  /**
   * Trạng thái sửa edit
   * @param e 
   */
  onEditItem(index) {
    this.isEdit[index] = true;
  }
  /**
   * Lưu thông tin đã sửa
   * @param e 
   */
  onSaveItem(e, index) {
    if (this.checkValidators(e.quantity)) {
      return;
    }
    const data = {
      quantity: e.quantity,
      productId: e.product.id,
    }
    this.n15Service.getChangeItem(data).subscribe({
      next: response => {
        this.isEdit[index] = false;
        this.dialog.open(ConfirmModalComponent, {
          data: {
            title: 'Thành công',
            type: 'success',
            content: 'Bạn đã sửa số lượng sản phẩm thành công.',
          },
        });
      }
    })
  }

  /**
   * Lấy giá trị mới khi lựa chọn số lượng
   * @param e 
   */
  setQuantity(e, index) {
    this.cart.items[index].cost = e * this.cart.items[index].product.price;
  }

  /**
   * Xóa item khỏi cart
   * @param e 
   */
  onDeleteItem(e) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Xóa khỏi giỏ hàng',
        content: `Bạn có muốn xóa "${e.product.name}" khỏi giỏ hàng  không?`,
        type: 'delete',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.n15Service.getDeleteItem(e.product.id).subscribe({
          next: response => {
            this.onSearch();
          }, error: error => {

          }
        })
      }
    });
  }
  /**
   * Chuyển sang bước tạo order
   */
  nextStep() {
    if (!this.cart.items || !(this.cart.items.length > 0)) {
      this.dialog.open(ConfirmModalComponent, {
        data: {
          title: 'Lỗi',
          type: 'success',
          content: 'Không có sản phẩm nào cần thanh toán.',
        },
      });
      return;
    }
    if (this.isEdit.includes(true)) {
      this.dialog.open(ConfirmModalComponent, {
        data: {
          title: 'Lỗi',
          type: 'success',
          content: 'Bạn cần lưu thông số lượng sản phẩm cần mua trước khi thanh toán.',
        },
      });
      return;
    }
    this.onSearch();
    this.formInfo.reset();
    this.n05Service.getListBank(1, 30000).subscribe({
      next: response => {
        this.dataSource = response.data.items;
      }
    });
    // this.dialogRef.disableClose = true;
    this.step = this.step + 1
  }

  /**
   * upload file
   * @returns 
   */
  uploadImage() {
    if (this.file_store) {
      const formData = new FormData();
      formData.append('file', this.file_store);
      return this.n15Service.getUploadFile(formData).pipe(map(x => x.data));
    }
    return of('');
  }

  modifyProduct(image: string) {
    const items = this.cart.items;
    let details = [];
    items.forEach(item => {
      details.push({
        productId: item.product.id,
        quantity: item.quantity
      });
    })
    let data = this.formInfo.getRawValue();
    data['details'] = details;
    data['evidenceImage'] = image;
    data['orderCode'] = this.cart.orderCode;
    return this.n15Service.getCreateOrder(data).pipe(
      map(() => ({
        content: 'Bạn đã mua hàng thành công.',
      }))
    );
  }

  /**
   * Xác nhận chuyển khoản
   */
  onSubmit() {
    if (this.formInfo.invalid) {
      this.formInfo.markAllAsTouched();
      return;
    }
    this.uploadImage()
      .pipe(switchMap(image => this.modifyProduct(image)))
      .subscribe({
        next: result => {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Thành công',
              type: 'success',
              ...result,
            },
          });
          this.dialogRef.close(true);
        },
      });
  }


  /**
   * Chọn 1 flie
   */
  handleFileInputChange(l: FileList): void {
    if (l.length) {
      const f = l[0];
      this.file_store = l[0];
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const imageUrl = event.target.result;
        this.urlImg = imageUrl;
      };
      reader.readAsDataURL(this.file_store);
      const count = l.length > 1 ? `(+${l.length - 1} files)` : "";
      this.fileName.patchValue(`${f.name}${count}`);
    } else {
      this.file_store = null;
      this.fileName.patchValue("");
    }
  }

  getErrorMessage(formControl) {
    if (formControl.hasError('required')) {
      return 'Không được bỏ trống';
    }
    if (formControl.hasError('minlength')) {
      return 'Nhập ít nhất 9 ký tự';
    }
    if (formControl.hasError('pattern')) {
      return 'Chỉ được nhập số';
    }
    return '';
  }

  onBack() {
    this.step = this.step - 1
  }

  checkValidators(quantity: number) {
    if (quantity <= 0) {
      return 'Số lượng phải >0';
    }
    return '';
  }
}
